<template>
  <div class="policyNotice">
    <div class="policyNotice-box">
      <h1 class="policyNotice-box-title" @click="openPolicy">
        <template v-if="!openState">
          <span>票务优惠政策，点击查看</span>
          <img src="~@/assets/image/entry/entry_more.png" alt="">
        </template>
        <template v-else>
          <span>票务优惠政策，点击隐藏</span>
          <img :class="{ 'rotate': openState }" src="~@/assets/image/entry/entry_more.png" alt="">
        </template>
      </h1>
      <ul v-if="openState" class="policyNotice-box-content">
        <!-- v-for="(policy, index) in policyList" :key="index"-->
        <li>
          <!-- v-if="policy.title" {{ policy.title }}-->
          <!-- <div class="title">优惠政策</div> -->
          <ul>
            <!-- <li v-for="text in policy.list" :key="text">{{ text }}</li> -->
            <img :src="imageUrl" style="max-width:100%;max-height:100%">
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getPolicy } from '@/utiles/common';
export default {
  name: "policyNotice",
  data() {
    return {
      openState: true,
      policyList: [],
      imageUrl: ''
    }
  },
  created(){
    this.initPolicy();
  },
  methods: {
    openPolicy(){
      this.openState = !this.openState;
    },
    // initPolicy(){
    //   const arr = this.$store.state.policy
    //   const policy = [arr[0],arr[1]];
    //   this.policyList = policy;
    // },
    async initPolicy(){
      try {
        const res = await getPolicy();
        let filterRes = res.filter(item=>item.subTitle == 'wx')
        this.imageUrl = filterRes[0].reserve1
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>

<style scoped lang='less'>
.policyNotice{
  padding: .166667rem .266667rem 0;
  .policyNotice-box{
    background: #FFFFFF;
    border-radius: .293333rem;
    .policyNotice-box-title{
      line-height: 1.066667rem;
      height: 1.066667rem;
      display: flex;
      align-items: center;
      justify-content: center;
      span{
        font-weight: 400;
        font-size: .4rem;
        color: #9D6C29;
      }
      img{
        width: .4rem;
        height: .4rem;
        margin-left: .133333rem;
      }
      .rotate{
        transform: rotate(90deg);
      }
    };
    .policyNotice-box-content{
      padding: .133333rem .266667rem .266667rem;
      font-size: .373333rem;
      color: #333333;
      line-height: .573333rem;
      .title{
        font-weight: bold;
      }
    }
  }
}
</style>
